// @flow

let config;

if (ENV && ENV.CLIENT) {
  config = window.SEEK_CONFIG;
} else {
  require('dotenv').config({ path: '.env', silent: true });
  config = process.env;
}

const getConfig = (key: string): string => {
  if (key in config) {
    return String(config[key]);
  }
  throw new Error(
    `Configuration Error: required environment variable "${key}" not found.`
  );
};

function getConfigOptionally(key: string, optional: boolean): ?string {
  if (key in config) {
    return config[key];
  }
  if (!optional) {
    throw new Error(
      `Configuration Error: required environment variable "${key}" not found.`
    );
  }
  return null;
}

const getConfigAsBool = key => getConfig(key) === 'true';

export const awsAccount = getConfigOptionally('AWS_ACCOUNT', true) || '';
export const raygunIsEnabled = getConfigAsBool('SEEK_RAYGUN_ENABLED');
export const raygunApiKey = getConfigOptionally(
  'SEEK_RAYGUN_API_KEY',
  !raygunIsEnabled
);
export const metricsIsEnabled = getConfigAsBool('SEEK_METRICS_ENABLED');
export const metricsPrefix = getConfigOptionally(
  'SEEK_METRICS_PREFIX',
  !metricsIsEnabled
);
export const warmupEnabled = getConfigAsBool('SEEK_WARMUP_ENABLED');
export const metricsHost = getConfigOptionally(
  'SEEK_METRICS_HOST',
  !metricsIsEnabled
);
export const statsdHost = getConfigOptionally(
  'SEEK_STATSD_HOST',
  !metricsIsEnabled
);
export const statsdPort = getConfigOptionally(
  'SEEK_STATSD_PORT',
  !metricsIsEnabled
);
export const analyticsIsEnabled = getConfigAsBool('SEEK_ANALYTICS_ENABLED');
export const countsUrl = getConfig('SEEK_API_COUNTS_ENDPOINT');
export const locationsUrl = getConfig('SEEK_API_LOCATIONS_ENDPOINT');
export const locationsPersonalisedSuggestUrl = getConfig(
  'SEEK_API_LOCATIONS_PERSONALISED_SUGGEST_ENDPOINT'
);
export const dashboardUrl = getConfig('SEEK_API_DASHBOARD_ENDPOINT');
export const candidateAccountUrl = getConfig(
  'SEEK_API_CANDIDATE_ACCOUNT_ENDPOINT'
);
export const saveLastSearchUrl = getConfig(
  'SEEK_API_SAVE_LAST_SEARCH_ENDPOINT'
);
export const saveSearchUrl = getConfig('SEEK_API_SAVE_SEARCH_ENDPOINT');
export const savedSearchesResourceApi = getConfig(
  'SEEK_API_SAVED_SEARCHES_RESOURCE_ENDPOINT'
);
export const jobMailUrl = getConfig('SEEK_API_JOB_MAIL_ENDPOINT');
export const saveJobUrl = getConfig('SEEK_API_SAVE_JOB_ENDPOINT');
export const nudgesUrl = getConfig('SEEK_API_NUDGES_ENDPOINT');
export const reportJobAdUrl = getConfig('SEEK_API_REPORTJOBAD_ENDPOINT');
export const sendJobUrl = getConfig('SEEK_API_SEND_JOB_ENDPOINT');
export const savedSearchesUrl = getConfig('SEEK_SAVED_SEARCHES_ENDPOINT');
export const authTokenUrl = getConfig('SEEK_API_AUTH_TOKEN_ENDPOINT');
export const searchUrl = getConfig('SEEK_API_SEARCH_ENDPOINT');
export const jobUrl = getConfig('SEEK_API_JOB_DETAILS_ENDPOINT');
export const jobApplicationUrl = getConfig(
  'SEEK_API_JOB_APPLICATIONS_ENDPOINT'
);
export const lmisUrl = getConfig('SEEK_LEARNING_LMIS_ENDPOINT');
export const relatedSearchesUrl = getConfig(
  'SEEK_API_RELATED_SEARCHES_ENDPOINT'
);
export const jobLogoUrlPrefix = getConfig('SEEK_JOB_LOGO_URL_PREFIX');

export const auditLoggerLevel = getConfig('SEEK_LOG_LEVEL');
export const loggerS3Bucket =
  getConfigOptionally('LOGGER_S3_BUCKET', true) || '';
export const loggerS3Path = getConfigOptionally('LOGGER_S3_PATH', true) || '';

export const stubHost = getConfigOptionally('SEEK_STUB_HOST', true);
export const stubPort = getConfigOptionally('SEEK_STUB_PORT', true);
export const environment = getConfig('SEEK_ENVIRONMENT');
export const isProduction = environment === 'production';
export const version = getConfig('SEEK_VERSION');
export const staticResourcePath = getConfig('SEEK_STATIC_RESOURCE_PATH');
export const advertsIsEnabled = getConfigAsBool('SEEK_ADVERTS_ENABLED');
export const signInRegUrlPrefix =
  getConfigOptionally('SEEK_SIGN_IN_REG_URL_PREFIX', true) || '';
export const signInPath = getConfig('SEEK_SIGN_IN_PATH');
export const registerPath = getConfig('SEEK_REGISTER_PATH');
export const jobTrackingEnabled = getConfigAsBool('SEEK_JOB_TRACKING_ENABLED');
export const jobTrackingUrl = getConfig('SEEK_JOB_TRACKING_URL');
export const useHotLoader =
  getConfigOptionally('SEEK_USE_HOT_LOADER', true) || false;
export const eventCaptureUrl = getConfig('SEEK_API_EVENT_CAPTURE_ENDPOINT');
export const hotjarEnabled = getConfigAsBool('SEEK_HOTJAR_ENABLED');

export const fitmeUrl = getConfig('SEEK_FITME_ENDPOINT');

export const savedSearchesPath = getConfig('SEEK_SAVED_SEARCHES_PATH');

// Experiments
export const experimentsEnabled = getConfigAsBool('SEEK_EXPERIMENTS_ENABLED');
export const experimentsPublicEndpoint = getConfig(
  'SEEK_API_EXPERIMENTS_PUBLIC_ENDPOINT'
);
export const experimentsPrivateEndpoint = getConfig(
  'SEEK_API_EXPERIMENTS_PRIVATE_ENDPOINT'
);

// Experiments ids
export const appInstallNativeExperimentId =
  'CB4F5932-7FC3-42A9-885C-973B2B0B46DA';
export const cisClickToRevealExperimentId =
  'B7FD20AF-605D-4D3C-8FF4-08089F4920ED';

export const activeExperiments = [
  appInstallNativeExperimentId,
  cisClickToRevealExperimentId
];

export const solConfig = {
  debug: false,
  apiHost: getConfig('SEEK_SOL_TRACKING_ENDPOINT')
};
